// LD-1 · Where it shows: the Hub API's routes (api2 src/modules/listing/listing.routes.ts). The checks come from the API
// (one rule file); the portal only shows them.
import { api } from '@/lib/hubApi'
import type { Channel, LenderListing } from '@/types'

const enc = encodeURIComponent

export const listingApi = {
  view: (slug: string) => api<LenderListing>('GET', `/lenders/${enc(slug)}/listing`),
  publish: (slug: string, channel: Channel) => api<LenderListing>('POST', `/lenders/${enc(slug)}/listing/${channel}/publish`),
  unpublish: (slug: string, channel: Channel) => api<LenderListing>('POST', `/lenders/${enc(slug)}/listing/${channel}/unpublish`),
}
